import React from 'react';
import Icon from '../../../components/AppIcon';

export default function ActivityFeed({ activities = [] }) {
  // Show empty state when no activities
  if (activities?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="font-heading font-semibold text-lg text-foreground mb-4">
          Recent Activity
        </h3>
        <div className="flex flex-col items-center justify-center py-8">
          <div className="w-12 h-12 bg-muted rounded-full flex items-center justify-center mb-3">
            <Icon name="Activity" size={20} className="text-muted-foreground" />
          </div>
          <p className="text-sm text-muted-foreground text-center">
            No recent activity yet
          </p>
          <p className="text-xs text-muted-foreground text-center mt-1">
            Your workspace activity will appear here
          </p>
        </div>
      </div>
    );
  }

  const getActivityIcon = (type) => {
    switch (type) {
      case 'created':
        return 'Plus';
      case 'edited':
        return 'Edit';
      case 'published':
        return 'Upload';
      case 'deleted':
        return 'Trash2';
      case 'duplicated':
        return 'Copy';
      default:
        return 'Activity';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'created':
        return 'text-success';
      case 'edited':
        return 'text-primary';
      case 'published':
        return 'text-accent';
      case 'deleted':
        return 'text-destructive';
      case 'duplicated':
        return 'text-muted-foreground';
      default:
        return 'text-muted-foreground';
    }
  };

  const formatTime = (date) => {
    const now = new Date();
    const activityDate = new Date(date);
    const diffMs = now - activityDate;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return activityDate?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading font-semibold text-base md:text-lg text-foreground">
          Recent Activity
        </h3>
        <Icon name="Activity" size={20} className="text-muted-foreground" />
      </div>
      <div className="space-y-4">
        {activities?.map((activity) => (
          <div key={activity?.id} className="flex gap-3">
            <div
              className={`w-8 h-8 rounded-full bg-muted flex items-center justify-center flex-shrink-0 ${getActivityColor(
                activity?.type
              )}`}
            >
              <Icon name={getActivityIcon(activity?.type)} size={16} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-foreground mb-1">
                <span className="font-medium">{activity?.projectName}</span> was {activity?.action}
              </p>
              <p className="text-xs text-muted-foreground">{formatTime(activity?.timestamp)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}